<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <CRow class="popupWindowCD"
                          role="dialog"
                          aria-labelledby="modalTitle"
                          aria-describedby="modalDescription">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["RWS"][obj_Reward.I > 0? "ER": "AR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["AG"]["GN"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mx-3">
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["PM"]["AGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_Reward.AGIT"
                                                              @input="AgentGroupChange"
                                                              :max-height="200"
                                                              :disabled="obj_Reward.I > 0"
                                                              ref="AGI" />
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('AGI','AG','GN') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["CI"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency2"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                        :disabled="obj_Reward.I > 0"
                                                        :clearable="false"
                                                        :max-height="200"
                                                        v-model="obj_Reward.CI"
                                                        @input="CurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('CI','MEM', 'CI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["SMB"]["RWS"]}}  </h6>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mx-3">
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["RWS"]["RN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['RWS']['RN']" size="sm" v-model="obj_Reward.RN" ref="RN"></CInput>
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('RN','RWS','RN') }}</span>
                                        </CCol>
                                        <CCol col="2" class="form-group">
                                            <label class="col-form-label-sm d-block">{{this.getLanguage["MTA"]["RS"]}} :</label>
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="obj_Reward.RS" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mx-3">
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["RWS"]["TOB"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_typeOfBonus"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['RWS']['TOB']"
                                                        v-model="obj_Reward.TOB"
                                                        :max-height="200"
                                                        :disabled="obj_Reward.I > 0"
                                                        ref="TOB" />
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('TOB','RWS','TOB') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["RWS"]["PPN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_prizePool"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['RWS']['PPN']"
                                                        v-model="obj_Reward.PPMI"
                                                         openDirection="above"
                                                        :max-height="200"
                                                        ref="PPMI" />
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('PPMI','RWS','PPN') }}</span>
                                        </CCol>
                                        <CCol col="3" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["RWS"]["MNG"]}}<span class="required" /> :</label>
                                            <div class="input-group">
                                                <treeselect :multiple="false"
                                                            :options="dd_miniGame"
                                                            :clearable="false"
                                                            :placeholder="getLanguage['RWS']['MNG']"
                                                            v-model="obj_Reward.MGI"
                                                             openDirection="above"
                                                            :max-height="200"
                                                            style="width: 80%"
                                                            ref="MGI" />
                                                <span class="input-group-text" style="cursor: pointer" v-if="obj_Reward.MGI" @click="setPreview">
                                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <span class="ErrMsg">{{ ValidationRewardErrMsg('MGI','RWS','MNG') }}</span>
                                        </CCol>
                                    </CRow>
                                    <div v-if="obj_Reward.TOB != 2">
                                        <CRow class="mx-3 mt-3">
                                            <CCol col="12">
                                                <strong>{{this.getLanguage['MSA']['AR']}}</strong>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol class="col-1" style="padding-right: 0px">
                                                <CRow>
                                                    <CCol style="max-width: 60px; padding-right: 0px">
                                                        <label class="col-form-label-sm full-width">
                                                            {{this.getLanguage['DLSS']['OF']}}
                                                        </label>
                                                    </CCol>
                                                    <CCol style="padding-top: 3px; padding-left: 0px; padding-right: 0px">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="obj_Reward.OO" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                            <CCol class="col-11">
                                                <CRow>
                                                    <CCol class="col-2" style="padding-right: 0px">
                                                        <label class="col-form-label-sm full-width">
                                                            {{this.getLanguage['DLSS']['LR']}}
                                                            <div class="custom_tooltip">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["MSALRQA"]}}</span>
                                                            </div>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-1" style="padding-top: 3px;">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="obj_Reward.LROO" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['CLD']}}</label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <CInput size="sm" class="inline w-100" v-model="obj_Reward.CLD" ref="CLD"></CInput>
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('CLD','DLSS','CLD') }}</span>
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol class="col-2" style="padding-right: 0px">
                                                        <label class="col-form-label-sm full-width">
                                                            {{this.getLanguage['DLSS']['DR']}}
                                                            <div class="custom_tooltip">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["DRQA"]}}</span>
                                                            </div>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-1" style="padding-top: 3px;">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="obj_Reward.DROO" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MDA']}} <span class="amountNote" v-if="getThousandCurrency"><br />{{getLanguage["GL"]["CUR"]}}</span></label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <CInput size="sm" class="inline w-100" :prepend="currencySymbol"
                                                                :value="ThousandSeparator(obj_Reward.MDA, getThousandCurrency ? 3 : 2)"
                                                                @change="v => obj_Reward.MDA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MDA"></CInput>
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('MDA','DLSS','MDA') }}</span>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MOA']}}</label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <CInput size="sm" class="inline w-100" v-model="obj_Reward.MCOD" ref="MCOD"></CInput>
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('MCOD','DLSS','MOA') }}</span>
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol class="col-2" style="padding-right: 0px">
                                                        <label class="col-form-label-sm full-width">
                                                            {{this.getLanguage['DLSS']['TR']}}
                                                            <div class="custom_tooltip">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 campaign-name">{{getLanguage["HELP"]["MSATRQA"]}}</span>
                                                            </div>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-1" style="padding-top: 3px;">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="obj_Reward.TROO" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MTA']}} <span class="amountNote" v-if="getThousandCurrency"><br />{{getLanguage["GL"]["CUR"]}}</span></label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <CInput size="sm" class="inline w-100" :prepend="currencySymbol"
                                                                :value="ThousandSeparator(obj_Reward.MTA, getThousandCurrency ? 3 : 2)"
                                                                @change="v => obj_Reward.MTA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" ref="MTA"></CInput>
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('MTA','DLSS','MTA') }}</span>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['DLSS']['MGP']}}</label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <CInput size="sm" class="inline w-100" v-model="obj_Reward.MBC" ref="MBC"></CInput>
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('MBC','DLSS','MGP') }}</span>
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol class="col-2" style="padding-right: 0px">
                                                        <label class="col-form-label-sm full-width">
                                                            {{this.getLanguage['MSA']['CDR']}}
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-1" style="padding-top: 3px;">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="obj_Reward.CDOO" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </CCol>
                                                    <CCol class="col-2">
                                                        <label class="col-form-label-sm full-width">{{this.getLanguage['MSA']['CD']}}</label>
                                                    </CCol>
                                                    <CCol class="col-4">
                                                        <treeselect :multiple="true"
                                                                    :options="dd_ContactDetailOption"
                                                                    :placeholder="getLanguage['MSA']['CD']"
                                                                    :max-height="200"
                                                                    v-model="obj_Reward.CD"
                                                                    openDirection="above"
                                                                    :limit="1"
                                                                    :limitText="count => `+${count}`"
                                                                    ref="CD" />
                                                        <span class="ErrMsg">{{ ValidationRewardErrMsg('CD','MSA','CD') }}</span>
                                                    </CCol>
                                                </CRow>
                                                <span class="ErrMsg" v-if="showReqValidation">{{ this.getLanguage['MSA']['AOIQR'] }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="saveReward()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </CRow>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["RS"]}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["AGI"] }}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["MEM"]["CI"] }}
                                                <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["RWS"]["RN"] }}
                                                <i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TOB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["RWS"]["TOB"] }}
                                                <i @click="setSortTable('TOB')" :class="setSortLogo('TOB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PPN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["RWS"]["PPN"] }}
                                                <i @click="setSortTable('PPN')" :class="setSortLogo('PPN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MNG'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["RWS"]["MNG"] }}
                                                <i @click="setSortTable('MGN')" :class="setSortLogo('MGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'WCON'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["RWS"]["WCON"] }}
                                                <i @click="setSortTable('WCON')" :class="setSortLogo('WCON')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["RWS"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addReward()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>
                        {{getLanguage['SMB']['RWS']}}
                        <div class="custom_tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="tooltiptext2 campaign-name" style="top: -40px;">{{getLanguage["HELP"]["DLSSQA"]}}</span>
                        </div>
                    </strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["RN"] }}
                                        <i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TOB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["TOB"] }}
                                        <i @click="setSortTable('TOB')" :class="setSortLogo('TOB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["PPN"] }}
                                        <i @click="setSortTable('PPN')" :class="setSortLogo('PPN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MNG'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["MNG"] }}
                                        <i @click="setSortTable('MGN')" :class="setSortLogo('MGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WCON'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["WCON"] }}
                                        <i @click="setSortTable('WCON')" :class="setSortLogo('WCON')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.add))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RS"]}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["MEM"]["CI"] }}
                                        <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["RN"] }}
                                        <i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TOB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["TOB"] }}
                                        <i @click="setSortTable('TOB')" :class="setSortLogo('TOB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PPN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["PPN"] }}
                                        <i @click="setSortTable('PPN')" :class="setSortLogo('PPN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MNG'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["MNG"] }}
                                        <i @click="setSortTable('MGN')" :class="setSortLogo('MGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WCON'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["RWS"]["WCON"] }}
                                        <i @click="setSortTable('WCON')" :class="setSortLogo('WCON')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Reward.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Reward">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-trash" @click='removeReward(data)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-color-border" @click='editReward(data.I)'></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-color-border"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.edit)">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <CCol col="4">
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="event => updateStatus(data, event)">
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </span>
                                    <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <CCol col="4">
                                            <label class="switch">
                                                <input type="checkbox" :checked="data.RS == 2" disabled />
                                                <span class="slider round" style="cursor: not-allowed; filter: none; pointer-events: none"></span>
                                            </label>
                                        </CCol>
                                    </span>
                                </template>
                                <template v-else-if="header == 'BN'">
                                    {{ data.GN }} ({{ data.GPC }})
                                </template>
                                <template v-else-if="header == 'CI'">
                                    {{ data.ISOC }}
                                </template>
                                <template v-else-if="header == 'RN'">
                                    {{ data.RN }}
                                </template>
                                <template v-else-if="header == 'TOB'">
                                    {{renderTypeOfBonus(data.TOB) }}
                                </template>
                                <template v-else-if="header == 'PPN'">
                                    {{ data.PPN }}
                                </template>
                                <template v-else-if="header == 'MNG'">
                                    {{ data.MGN }}
                                </template>
                                <template v-else-if="header == 'WCON'">
                                    {{renderConditionType(data.OO) }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, numeric, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                arr_FV: {
                    "AGI": null,
                    "CI": null,
                    //"CTS": {
                    //    startDate: "",
                    //    endDate: ""
                    //},
                },

                arr_Reward: [],

                obj_Reward: {},
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_typeOfBonus: [],
                dd_prizePool: [],
                dd_miniGame: [],

                bool_RewardCV: false,
                dd_currency: [],
                dd_currency2: [],
                constAccessType: constAccessType,
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'BN', 'CI', 'RN', 'TOB', 'PPN', 'MNG', 'WCON'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                currencySymbol: '',
                dd_ContactDetailOption: [],
                bool_fullPreview: false,
                previewUrl: null,
                showReqValidation: false
            }
        },
        validations: {
            obj_Reward: {
                "RN": { required },
                "AGI": { required },
                "CI": { required },
                "TOB": { required },
                "PPMI": { required },
                "MGI": { required },
                "MDA": {
                    required: requiredIf(function () {
                        return this.obj_Reward.DROO;
                    }),
                    decimal,
                    minValue: minValue(0)
                },
                "MCOD": {
                    required: requiredIf(function () {
                        return this.obj_Reward.DROO;
                    }),
                    numeric,
                    minValue: minValue(0)
                },
                "MTA": {
                    required: requiredIf(function () {
                        return this.obj_Reward.TROO;
                    }),
                    decimal,
                    minValue: minValue(0)
                },
                "MBC": {
                    required: requiredIf(function () {
                        return this.obj_Reward.TROO;
                    }),
                    numeric,
                    minValue: minValue(0)
                },
                "CLD": {
                    required: requiredIf(function () {
                        return this.obj_Reward.LROO;
                    }),
                    numeric,
                    minValue: minValue(1)
                },
                "CD": {
                    required: requiredIf(function () {
                        return this.obj_Reward.CDOO;
                    })
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC', 'checkModuleIndex']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_RewardCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getDropdownList();
                this.getRewardList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/PrizeReward`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.add))) {
                                    that.removeDefaultColumn('RS')
                                    that.removeColumn('RS')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/PrizeReward/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            
            checkModuleAccess2(type) {
                return this.checkModuleAccess('RWS', 'P', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_RewardCV = false;
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getRewardList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getRewardList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getRewardList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            CurrencyChange(value) {
                this.dd_prizePool = [];
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.currencySymbol = val.label;
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                        }
                    });
                    
                    if (this.obj_Reward.AGIT) {
                        var agi = this.obj_Reward.AGIT.split("-")[1];
                        this.getDataApi(`/api/dd/ppl/${agi}/${value}`,
                            function (d, s) {
                                if (s) {
                                    that.dd_prizePool = d.dropdownlist;
                                }
                            });
                    }
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getDropdownList() {
                var that = this;

                this.dd_typeOfBonus = [
                    {
                        id: 1,
                        label: this.getLanguage["TOB"]["DLB"]
                    },
                    {
                        id: 2,
                        label: this.getLanguage["TOB"]["MB"]
                    },
                    //{
                    //    id: 3,
                    //    label: this.getLanguage["TOB"]["PRER"]
                    //}
                ];

                this.dd_ContactDetailOption = [
                    {
                        id: 1,
                        label: this.getLanguage['MEM']['E']
                    },
                    {
                        id: 4,
                        label: this.getLanguage['MEM']['LID']
                    },
                    {
                        id: 2,
                        label: this.getLanguage['MEM']['PN']
                    },
                    {
                        id: 6,
                        label: this.getLanguage['MEM']['TGID']
                    },
                    {
                        id: 3,
                        label: this.getLanguage['MEM']['WC']
                    },                   
                    {
                        id: 5,
                        label: this.getLanguage['MEM']['WAID']
                    },
                    {
                        id: 7,
                        label: this.getLanguage['MEM']['ZLID']
                    }
                ];
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });

                this.getDataApi(`/api/dd/minigame`,
                    function (d, s) {
                        if (s) {
                            that.dd_miniGame = d.dropdownlist;
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            
            renderTypeOfBonus(id) {
                let typeText = '-';
                const type = this.dd_typeOfBonus.find(f => f.id == id);
                if (type)
                    typeText = type.label;
                return typeText;
            },
            renderConditionType(status) {
                return status ? this.getLanguage['GL']['YES'] : this.getLanguage['DLSS']['NA'];
            },
            getRewardList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"])
                    );

                    //if (this.arr_FV.CTS.startDate != "") {
                    //    var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                    //    path += "&f.CTS_from=" + cts_from;
                    //}
                    //if (this.arr_FV.CTS.endDate != "") {
                    //    var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                    //    path += "&f.CTS_to=" + cts_to;
                    //}
                }

                this.getDataApi(`/api/preward/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Reward = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            AgentGroupChange(value) {
                var that = this;
                var agi = 0;
                if (value) {
                    agi = value.split("-")[1];
                    this.obj_Reward.AGI = agi;
                    this.getDataApi('/api/dd/cur/' + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_currency2 = d.dropdownlist;
                                if (that.obj_Reward.I > 0) {
                                    that.CurrencyChange(that.obj_Reward.CI);
                                }

                                if (that.dd_currency2.length == 1) {
                                    that.obj_Reward.CI = that.dd_currency2[0].id;
                                    that.CurrencyChange(that.dd_currency2[0].id);
                                }
                            }
                        });
                }
            },
            AgentGroupChangefs(value) {
                var agi = 0;

                if (value != undefined) {
                    if (value != "") {
                        this.arr_FV["AGI"] = value;
                        agi = this.arr_FV["AGI"].split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            ValidationRewardErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_RewardCV) {
                    if (langKey1 == "") {
                        langKey1 = "RWS";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }
                    var validateObj = this.$v.obj_Reward[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1033'), this.getLanguage[langKey1][langKey2], validateObj.$params.minValue.min);
                    }
                }
            },
            addReward() {
                this.bool_RewardCV = false;
                this.bool_fullLoading = true;
                this.obj_Reward = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "SAGAGI": null,
                    "AGIT": null,
                    "CI": null,
                    "RN": "",
                    "TOB": null,
                    "PPMI": null,
                    "MGI": null,
                    "CLD": null,
                    "MDA": 0,
                    "MCOD": null,
                    "MTA": 0,
                    "MBC": null,
                    "CDL": "",
                    "CD": null,
                    "OO": false,
                    "DROO": false,
                    "TROO": false,
                    "LROO": false,
                    "CDOO": false
                };
                this.dd_prizePool = [];
                this.showReqValidation = false;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_Reward.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_Reward.AGIT);
                    }
                }
                this.bool_fullLoading = false;
                this.bool_isAMV = true;
            },
            editReward(id) {
                var that = this;
                this.showReqValidation = false;
                this.bool_fullLoading = true;
                this.bool_RewardCV = false;
                this.dd_prizePool = [];
                this.getDataApi(`/api/preward/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_Reward = Object.assign(that.obj_Reward, d.D);

                            if (that.obj_Reward.AGI != 0) {
                                that.obj_Reward.AGIT = "3-" + that.obj_Reward.AGI;
                                that.AgentGroupChange(that.obj_Reward.AGIT);
                            }
                            if (that.obj_Reward.CLD == 0)
                                that.obj_Reward.CLD = null;

                            that.bool_isAMV = true;
                        }   
                    });
            },
            saveReward() {
                var that = this;
                if (this.obj_Reward.AGIT != null && this.obj_Reward.AGIT.length > 0) {
                    var agi = this.obj_Reward.AGIT.split("-");
                    this.obj_Reward.AGI = agi[1];
                }                
                this.bool_RewardCV = true;
                this.$v.obj_Reward.$touch();
                
                if (!this.$v.obj_Reward.$error) {

                    if (this.obj_Reward.OO && !this.obj_Reward.LROO && !this.obj_Reward.DROO && !this.obj_Reward.TROO && !this.obj_Reward.CDOO) {
                        this.showReqValidation = true;
                        return;
                    }                    
                    this.showReqValidation = false;
                    if (this.obj_Reward.CD != null && this.obj_Reward.CD.length > 0) {
                        this.obj_Reward.CDL = this.obj_Reward.CD.join(',');
                    } else {
                        this.obj_Reward.CDL = "";
                    }

                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/preward/s`, this.obj_Reward,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getRewardList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_Reward"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeReward(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            ci: d.CI
                        };

                        this.postDataApi(`/api/preward/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getRewardList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            updateStatus(d, event) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        this.postDataApi(`/api/preward/us`, d,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.bool_isAMV = false;
                                    that.getRewardList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        event.target.checked = !event.target.checked;
                    }
                });

            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            setPreview() {
                if (this.obj_Reward.MGI) {
                    const MiniGame = this.dd_miniGame.find(f => f.id == this.obj_Reward.MGI);
                    if (MiniGame) {
                        this.previewUrl = MiniGame.label2;
                        this.bool_fullPreview = true;
                    }
                }
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'P';
            this.$parent.showSubSubMenu = 'RS8';
            this.$parent.showActiveMenu = 'P.RWS';
            this.getDropdownList();
            this.getCurrencyList();
            this.getRewardList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/PrizeRewardSetup.vue